/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ConnectedGoogleAnalyticsAccountsFragment = { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly connectedGoogleAnalyticsAccounts: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsAccount', readonly id: CK.ID, readonly name: string, readonly properties: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsProperty', readonly id: CK.ID, readonly name: string, readonly version: GraphQL.GoogleAnalyticsVersion, readonly views: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsView', readonly id: CK.ID, readonly name: string }> | null }> }> | null };

export type SuggestedGoogleAnalyticsAccountFragment = { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly suggestedGoogleAnalyticsAccount: { readonly __typename?: 'SuggestedGoogleAnalyticsAccount', readonly googleAnalyticsAccountId: CK.ID | null, readonly googleAnalyticsPropertyId: CK.ID | null, readonly googleAnalyticsViewId: CK.ID | null } };

export type ConnectedGoogleAnalyticsAccountsQueryVariables = GraphQL.Exact<{
  accountId: GraphQL.Scalars['AccountId']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type ConnectedGoogleAnalyticsAccountsQuery = { readonly __typename?: 'Query', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly connectedGoogleAnalyticsAccounts: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsAccount', readonly id: CK.ID, readonly name: string, readonly properties: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsProperty', readonly id: CK.ID, readonly name: string, readonly version: GraphQL.GoogleAnalyticsVersion, readonly views: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsView', readonly id: CK.ID, readonly name: string }> | null }> }> | null } | null, readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly suggestedGoogleAnalyticsAccount: { readonly __typename?: 'SuggestedGoogleAnalyticsAccount', readonly googleAnalyticsAccountId: CK.ID | null, readonly googleAnalyticsPropertyId: CK.ID | null, readonly googleAnalyticsViewId: CK.ID | null } } | null };

export type ConnectGoogleAnalyticsAccountMutationVariables = GraphQL.Exact<{
  authCode: GraphQL.Scalars['String']['input'];
  ownerAccountId: GraphQL.Scalars['AccountId']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type ConnectGoogleAnalyticsAccountMutation = { readonly __typename?: 'Mutation', readonly ConnectGoogleAnalyticsAccount: { readonly __typename?: 'BasicMutationResult', readonly query: { readonly __typename?: 'Query', readonly authenticatedSession: { readonly __typename?: 'AuthenticatedSession', readonly memberships: ReadonlyArray<{ readonly __typename?: 'AccountMembership', readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly sharedColumnSets: ReadonlyArray<{ readonly __typename?: 'ColumnSet', readonly id: CK.ColumnSetId, readonly isDefault: boolean, readonly name: string, readonly columns: ReadonlyArray<{ readonly __typename?: 'ColumnSetColumn', readonly enabled: boolean, readonly name: CK.PagesColumn }> }> }, readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string } }>, readonly personalColumnSets: ReadonlyArray<{ readonly __typename?: 'ColumnSet', readonly id: CK.ColumnSetId, readonly isDefault: boolean, readonly name: string, readonly columns: ReadonlyArray<{ readonly __typename?: 'ColumnSetColumn', readonly enabled: boolean, readonly name: CK.PagesColumn }> }> } | null, readonly website: { readonly __typename?: 'Website', readonly id: CK.WebsiteId, readonly account: { readonly __typename?: 'Account', readonly id: CK.AccountId, readonly connectedGoogleAnalyticsAccounts: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsAccount', readonly id: CK.ID, readonly name: string, readonly properties: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsProperty', readonly id: CK.ID, readonly name: string, readonly version: GraphQL.GoogleAnalyticsVersion, readonly views: ReadonlyArray<{ readonly __typename?: 'GoogleAnalyticsView', readonly id: CK.ID, readonly name: string }> | null }> }> | null } | null, readonly suggestedGoogleAnalyticsAccount: { readonly __typename?: 'SuggestedGoogleAnalyticsAccount', readonly googleAnalyticsAccountId: CK.ID | null, readonly googleAnalyticsPropertyId: CK.ID | null, readonly googleAnalyticsViewId: CK.ID | null } } | null } } };

export const ConnectedGoogleAnalyticsAccountsFragmentDoc = gql`
    fragment ConnectedGoogleAnalyticsAccounts on Account {
  id
  connectedGoogleAnalyticsAccounts {
    id
    name
    properties {
      id
      name
      version
      views {
        id
        name
      }
    }
  }
}
    `;
export const SuggestedGoogleAnalyticsAccountFragmentDoc = gql`
    fragment SuggestedGoogleAnalyticsAccount on Website {
  id
  suggestedGoogleAnalyticsAccount {
    googleAnalyticsAccountId
    googleAnalyticsPropertyId
    googleAnalyticsViewId
  }
}
    `;
export const ConnectedGoogleAnalyticsAccountsDocument = gql`
    query ConnectedGoogleAnalyticsAccounts($accountId: AccountId!, $websiteId: WebsiteId!) {
  account(id: $accountId) {
    ...ConnectedGoogleAnalyticsAccounts
  }
  website(id: $websiteId) {
    ...SuggestedGoogleAnalyticsAccount
  }
}
    ${ConnectedGoogleAnalyticsAccountsFragmentDoc}
${SuggestedGoogleAnalyticsAccountFragmentDoc}`;

/**
 * __useConnectedGoogleAnalyticsAccountsQuery__
 *
 * To run a query within a React component, call `useConnectedGoogleAnalyticsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConnectedGoogleAnalyticsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConnectedGoogleAnalyticsAccountsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useConnectedGoogleAnalyticsAccountsQuery(baseOptions: Apollo.QueryHookOptions<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables> & ({ variables: ConnectedGoogleAnalyticsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables>(ConnectedGoogleAnalyticsAccountsDocument, options);
      }
export function useConnectedGoogleAnalyticsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables>(ConnectedGoogleAnalyticsAccountsDocument, options);
        }
export function useConnectedGoogleAnalyticsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables>(ConnectedGoogleAnalyticsAccountsDocument, options);
        }
export type ConnectedGoogleAnalyticsAccountsQueryHookResult = ReturnType<typeof useConnectedGoogleAnalyticsAccountsQuery>;
export type ConnectedGoogleAnalyticsAccountsLazyQueryHookResult = ReturnType<typeof useConnectedGoogleAnalyticsAccountsLazyQuery>;
export type ConnectedGoogleAnalyticsAccountsSuspenseQueryHookResult = ReturnType<typeof useConnectedGoogleAnalyticsAccountsSuspenseQuery>;
export type ConnectedGoogleAnalyticsAccountsQueryResult = Apollo.QueryResult<ConnectedGoogleAnalyticsAccountsQuery, ConnectedGoogleAnalyticsAccountsQueryVariables>;
export const ConnectGoogleAnalyticsAccountDocument = gql`
    mutation ConnectGoogleAnalyticsAccount($authCode: String!, $ownerAccountId: AccountId!, $websiteId: WebsiteId!) {
  ConnectGoogleAnalyticsAccount(
    authCode: $authCode
    ownerAccountId: $ownerAccountId
    websiteId: $websiteId
  ) {
    query {
      authenticatedSession {
        memberships {
          account {
            id
            sharedColumnSets {
              columns {
                enabled
                name
              }
              id
              isDefault
              name
            }
          }
          user {
            id
            legacyId
          }
        }
        personalColumnSets {
          columns {
            enabled
            name
          }
          id
          isDefault
          name
        }
      }
      website(id: $websiteId) {
        account {
          ...ConnectedGoogleAnalyticsAccounts
        }
        ...SuggestedGoogleAnalyticsAccount
      }
    }
  }
}
    ${ConnectedGoogleAnalyticsAccountsFragmentDoc}
${SuggestedGoogleAnalyticsAccountFragmentDoc}`;
export type ConnectGoogleAnalyticsAccountMutationFn = Apollo.MutationFunction<ConnectGoogleAnalyticsAccountMutation, ConnectGoogleAnalyticsAccountMutationVariables>;

/**
 * __useConnectGoogleAnalyticsAccountMutation__
 *
 * To run a mutation, you first call `useConnectGoogleAnalyticsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGoogleAnalyticsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGoogleAnalyticsAccountMutation, { data, loading, error }] = useConnectGoogleAnalyticsAccountMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      ownerAccountId: // value for 'ownerAccountId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useConnectGoogleAnalyticsAccountMutation(baseOptions?: Apollo.MutationHookOptions<ConnectGoogleAnalyticsAccountMutation, ConnectGoogleAnalyticsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConnectGoogleAnalyticsAccountMutation, ConnectGoogleAnalyticsAccountMutationVariables>(ConnectGoogleAnalyticsAccountDocument, options);
      }
export type ConnectGoogleAnalyticsAccountMutationHookResult = ReturnType<typeof useConnectGoogleAnalyticsAccountMutation>;
export type ConnectGoogleAnalyticsAccountMutationResult = Apollo.MutationResult<ConnectGoogleAnalyticsAccountMutation>;
export type ConnectGoogleAnalyticsAccountMutationOptions = Apollo.BaseMutationOptions<ConnectGoogleAnalyticsAccountMutation, ConnectGoogleAnalyticsAccountMutationVariables>;